import type MatomoTracker from '@jonkoops/matomo-tracker';
import { create } from 'zustand';

interface TrackingStore {
  matomoTracker?: MatomoTracker;
  setMatomoTracker: ({ matomoTracker }: { matomoTracker: MatomoTracker | undefined }) => void;
}

const initialState = {
  matomoTracker: undefined,
};

export const useTrackingStore = create<TrackingStore>()((set) => ({
  ...initialState,
  setMatomoTracker: ({ matomoTracker }) => set({ matomoTracker }),
}));
